// extracted by mini-css-extract-plugin
export default {"button":"delete-column_button__6TfG2"};